import React from 'react'

const Error = () => {
  return (
    <div>404 Not Found</div>
  )
}

export default Error